/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Office_LogoInputs */

const cs_draft_office_logo = /** @type {(inputs: Draft_Office_LogoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo kanceláře`)
};

const en_draft_office_logo = /** @type {(inputs: Draft_Office_LogoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Office logo`)
};

/**
* | output |
* | --- |
* | "Office logo" |
*
* @param {Draft_Office_LogoInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const draft_office_logo = /** @type {((inputs?: Draft_Office_LogoInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Office_LogoInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_draft_office_logo(inputs)
	return cs_draft_office_logo(inputs)
});